import { useEffect, useRef } from "react";
import { track } from "@/lib/api";

// Fire a single tracking event the first time a section scrolls into view.
export default function useTrackInView(event, label = "") {
  const ref = useRef(null);
  const fired = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || fired.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !fired.current) {
            fired.current = true;
            track(event, label);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [event, label]);
  return ref;
}
